import styled from 'styled-components';

import {ms} from '../../../styles';
import {View} from '../../../uikit/View';

export const Container = styled(View)`
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  gap: ${ms(20)};
`;

export const Row = styled(View)`
  flex-direction: row;
  justify-content: center;
  gap: ${ms(8)};
`;
